import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Line } from "@antv/g2plot";
import chartMixin from "../mixin/chartMixin";
export default {
  name: "NewUserChart",
  mixins: [chartMixin],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getData: function getData(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                chartName: "ads_user_new_register_chart",
                grain: _this.communityGrain,
                groupBy: type,
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                valueName: "num"
              };
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api.getPostChartData(param).then(function (res) {
                  var data = res.data.map(function (i) {
                    return _objectSpread(_objectSpread({}, i), {}, {
                      type: type ? i.type : "all"
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getPostChartData: function getPostChartData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, Promise.all([_this2.getData(""), _this2.getData("type")]).then(function (res) {
                if (res.length) {
                  return res.flat(2);
                }
                return [];
              }));
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.getPostChartData();
            case 1:
              data = _context3.v;
              _this3.loading = false;
              if (_this3.lineChart) {
                _this3.lineChart.changeData(data);
              } else {
                _this3.lineChart = new Line("newUserChart", {
                  data: data,
                  xField: "time",
                  yField: "num",
                  seriesField: "type",
                  legend: {
                    position: "top",
                    offsetY: 70,
                    visible: true,
                    // 手动指定图例项及顺序
                    items: [{
                      name: "all",
                      value: "all",
                      marker: {
                        style: {
                          fill: "#5B8FF9",
                          stroke: "#5B8FF9",
                          size: 12
                        }
                      }
                    }, {
                      name: "landlord",
                      value: "landlord",
                      marker: {
                        style: {
                          fill: "#5BD9A7",
                          stroke: "#5BD9A7",
                          size: 12
                        }
                      }
                    }, {
                      name: "tenant",
                      value: "tenant",
                      marker: {
                        style: {
                          fill: "#5D7192",
                          stroke: "#5D7192",
                          size: 12
                        }
                      }
                    }]
                  },
                  color: function color(_ref) {
                    var type = _ref.type;
                    var obj = {
                      all: "#5B8FF9",
                      landlord: "#5BD9A7",
                      tenant: "#5D7192"
                    };
                    return obj[type] || "#5B8FF9";
                  },
                  smooth: true,
                  appendPadding: [70, 0, 0, 0]
                });
                _this3.lineChart.render();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};